export default __webpack_public_path__ + "static/media/Asset189.8ecff965.svg";